export const UPLOAD_PRODUCT_REQUEST = "UPLOAD_PRODUCT_REQUEST";
export const UPLOAD_PRODUCT_SUCCESS = "UPLOAD_PRODUCT_SUCCESS";
export const UPLOAD_PRODUCT_FAILURE = "UPLOAD_PRODUCT_FAILURE";

//MEN PRODUCT
export const MEN_PRODUCT_REQUEST = "MEN_PRODUCT_REQUEST";
export const MEN_PRODUCT_SUCCESS = "MEN_PRODUCT_SUCCESS";
export const MEN_PRODUCT_FAILURE = "MEN_PRODUCT_FAILURE";
//WOMEN PRODUCT
export const WOMEN_PRODUCT_REQUEST = "WOMEN_PRODUCT_REQUEST";
export const WOMEN_PRODUCT_SUCCESS = "WOMEN_PRODUCT_SUCCESS";
export const WOMEN_PRODUCT_FAILURE = "WOMEN_PRODUCT_FAILURE";
//KIDS PRODUCT
export const KIDS_PRODUCT_REQUEST = "KIDS_PRODUCT_REQUEST";
export const KIDS_PRODUCT_SUCCESS = "KIDS_PRODUCT_SUCCESS";
export const KIDS_PRODUCT_FAILURE = "KIDS_PRODUCT_FAILURE";
//GET SINGLE PRODUCT
export const GET_PRODUCT_REQUEST = "GET_PRODUCT_REQUEST";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_FAILURE = "GET_PRODUCT_FAILURE";
// Make PAYMENT
export const STRIPE_PAYMENT_REQUEST = "STRIPE_PAYMENT_REQUEST";
export const STRIPE_PAYMENT_SUCCESS = "STRIPE_PAYMENT_SUCCESS";
export const STRIPE_PAYMENT_FAILURE = "STRIPE_PAYMENT_FAILURE";
